import { ReactElement } from 'react';
import { useTranslate } from '@client/i18n/hooks';
import { BackButton } from '@client/myAccount/common/components/BackButton';
import { SearchResults } from '@client/myAccount/rma/components/SearchResults';
import { CARD_BOX_TITLE_SIZE, CardBox } from 'b2b-components/theme/components/CardBox';
import { SearchFieldContainer as SearchField } from './SearchField/SearchFieldContainer';
import { Props } from './SearchPage.types';
import './SearchPage.scss';

export const SearchPage = ({ backButtonUrl, searchRmasRecord }: Props): ReactElement => {
  const t = useTranslate();
  const { data: searchRmas, isLoaded: isSearchRmasLoaded } = searchRmasRecord;

  return (
    <>
      <BackButton
        className='MyAccount-BackButton--TopSide'
        url={backButtonUrl}
      >
        {t('Back to Active RMA list')}
      </BackButton>

      <CardBox title={t('Create new RMA')} titleSize={CARD_BOX_TITLE_SIZE.large}>
        <div className='RmaSearchPage-Search'>
          <div className='RmaSearchPage-Header'>{t('Search for items or invoices')}</div>

          <SearchField />
        </div>

        {isSearchRmasLoaded && searchRmas && (
          <SearchResults
            areResultsLimited={searchRmas.count < searchRmas.totalCount}
            isStandalone={false}
            resultCount={searchRmas.count}
            results={searchRmas.invoices}
          />
        )}
      </CardBox>

      <BackButton
        className='MyAccount-BackButton--BottomSide'
        url={backButtonUrl}
      >
        {t('Back to Active RMA list')}
      </BackButton>
    </>
  );
};

